import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onRequestQuote }) => {
  const handleRequestQuote = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    onRequestQuote(service);
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-subtle hover:shadow-moderate transition-all duration-300 group overflow-hidden">
      <div className="relative overflow-hidden">
        <Image
          src={service?.image}
          alt={service?.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 right-3">
          {service?.isPopular && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-accent text-accent-foreground">
              <Icon name="Star" size={12} className="mr-1" />
              Popular
            </span>
          )}
          {service?.isNew && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-success text-success-foreground">
              New
            </span>
          )}
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
              {service?.title}
            </h3>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground">
              {service?.category}
            </span>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
          {service?.description}
        </p>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={14} />
              <span>{service?.timeline}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Users" size={14} />
              <span>{service?.teamSize}</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm text-muted-foreground">Starting from</p>
            <p className="text-lg font-semibold text-foreground">
              {service?.priceRange}
            </p>
          </div>
          <div className="flex items-center space-x-1 text-sm text-muted-foreground">
            <Icon name="Star" size={14} className="text-accent" />
            <span>{service?.rating}</span>
            <span>({service?.reviews})</span>
          </div>
        </div>

        <div className="flex space-x-2">
          <Link to={`/service-details?id=${service?.id}`} className="flex-1">
            <Button variant="outline" className="w-full">
              <Icon name="Info" size={16} className="mr-2" />
              Learn More
            </Button>
          </Link>
          <Button
            variant="default"
            onClick={handleRequestQuote}
            className="flex-1"
          >
            <Icon name="FileText" size={16} className="mr-2" />
            Request Quote
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;